/*
 * @Author: wangshengqiang
 * @Date: 2021-05-11 09:52:50
 * @LastEditTime: 2021-05-11 11:35:00
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React from 'react';
import { Button } from 'zarm';
import './index.less';

const SimpleButton = props => {
  const {
    onClick,
    text = '',
    disabledClick: propsDisabledClick
  } = props;

  if (!text) {
    return null;
  }

  const disabledClick = () => {
    if (!props.disabled) {
      return;
    }

    propsDisabledClick();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "c-confirmButton-component",
    onClick: disabledClick
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    className: "confirmButton",
    block: true,
    theme: "primary",
    disabled: props.disabled
  }, text));
};

export default SimpleButton;